import React from 'react';
import { ExtendedNav } from '@trussworks/react-uswds';

export function USWDSExtendedNav(props) {
  return <ExtendedNav {...props} />;
}
